module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('page-title', [_c('h3', [_vm._v("Lista umów")]), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'AgreementCreate',
        query: {
          customer: _vm.id
        }
      },
      "title": "Dodaj umowę"
    }
  }, [_c('span', [_vm._v("Dodaj umowę")]), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['fullNumber']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("date")(item['date'])))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['leftToPaid']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.currency.name))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_c('span', {
      staticClass: "element_status",
      class: item.status
    }, [_vm._v(_vm._s(_vm._f("translate")(item['status'])))])]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['invoiceData']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1)], 1)])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Numer")]), _vm._v(" "), _c('th', [_vm._v("Data zawarcia")]), _vm._v(" "), _c('th', [_vm._v("Do zapłaty")]), _vm._v(" "), _c('th', [_vm._v("Waluta")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Faktura")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-741aec59","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/AgreementList.vue
// module id = 825
// module chunks = 0